import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength } from "vuelidate/lib/validators";
import { passwordErrorMessageMixin, lettersAndNumbersMixin } from "~/mixins";
import { NoContentError, ConflictError } from "~/abstractions/errors";
import VueRecaptcha from "vue-recaptcha";
import { recaptcha } from "../enums";

export default {
  layout: "login",
  mixins: [passwordErrorMessageMixin, lettersAndNumbersMixin],
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit("dashboard/details/setToolbarTitle", "Iniciar sesión");

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),
  data: function data() {
    var sitekey = process.env.recatpchaSiteKey;

    return {
      user: '',
      errorMessage: "Usuario o contraseña incorrecta",
      loginText: "Iniciar sesión",
      buttonDisabled: false,
      buttonDisabled2: false,
      loading: false,
      loading2: false,
      password: "",
      title: "INICIO DE SESIÓN",
      isLoginError: false,
      sitekey: sitekey,
      captchaToken: '',
      expiredCaptchaToken: false,
      isRecaptchaLoaded: false
    };
  },

  // head() {
  //   return {
  //     title: 'Vue recaptcha - v2',
  //     script: [
  //       {
  //         hid: 'recaptcha',
  //         src: 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit',
  //         defer: true,
  //         callback: () => { this.isRecaptchaLoaded = true }
  //       }
  //     ]
  //   }
  // },
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  validations: {
    user: {
      required: required,
      minLength: minLength(4)
    },
    password: {
      required: required,
      minLength: minLength(6)
    },
    captchaToken: {
      required: required
    }
  },
  methods: {
    forgotPassword: function forgotPassword() {
      this.$router.push("/forgot-password");
    },
    getUrlAD: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref4, url;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.buttonDisabled = true;
                this.buttonDisabled2 = true;
                this.loading = false;
                this.loading2 = true;

                _context2.prev = 4;
                _context2.next = 7;
                return this.$store.dispatch("user/getAuthUrl", {});

              case 7:
                _ref4 = _context2.sent;
                url = _ref4.url;

                window.location.href = url;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](4);

                if (_context2.t0 instanceof NoContentError) {
                  this.isLoginError = true;
                } else if (_context2.t0 instanceof ConflictError) {
                  this.isLoginError = true;
                  this.errorMessage = _context2.t0.message;
                } else {
                  this.$controlMessage(_context2.t0);
                }

              case 15:

                this.loading2 = false;
                this.buttonDisabled = false;
                this.buttonDisabled2 = false;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 12]]);
      }));

      function getUrlAD() {
        return _ref3.apply(this, arguments);
      }

      return getUrlAD;
    }(),
    onSubmit: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _ref6, idRole, subChannelName, channelName, numeroIntentos2, numeroIntentos, message, response, numberAttemps, userBlocked, minutes, diff, minutos;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$v.$touch();

                if (!this.$v.$invalid) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:

                this.sending = true;
                this.loginText = "Cargando...";
                this.loading = true;

                this.buttonDisabled2 = true;
                this.loading2 = false;

                _context3.prev = 8;
                _context3.next = 11;
                return this.$store.dispatch("user/authLogin", {
                  user: this.user,
                  password: this.password,
                  recaptchaToken: this.captchaToken
                });

              case 11:
                _ref6 = _context3.sent;
                idRole = _ref6.idRole;
                subChannelName = _ref6.subChannelName;
                channelName = _ref6.channelName;

                console.log(subChannelName, channelName);
                if (idRole === 5) this.$router.push("/bosses"); // el usuario es administrador de colaboradores
                else if (idRole === 6) this.$router.push("/tariff"); // el usuario es gestor de tarifas;
                  else this.$router.push("/dashboard");
                _context3.next = 22;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](8);

                if (_context3.t0 instanceof NoContentError) {

                  this.isLoginError = true;
                } else if (_context3.t0 instanceof ConflictError) {

                  this.isLoginError = true;

                  numeroIntentos2 = 3;
                  numeroIntentos = 0;
                  message = _context3.t0.message, response = _context3.t0.response;


                  if (!response) this.errorMessage = message;else {
                    numberAttemps = response.numberAttemps, userBlocked = response.userBlocked, minutes = response.minutes;

                    if (!userBlocked) {
                      numeroIntentos = numberAttemps;
                      diff = numeroIntentos2 - numeroIntentos;

                      this.errorMessage = "Datos incorrectos. Te quedan " + diff + " intento(s).";
                    } else {
                      minutos = minutes === 0 ? 1 : minutes;

                      this.errorMessage = "Su cuenta ha sido bloqueada. Int\xE9ntelo dentro de " + minutos + " minuto(s).";
                    }
                  }

                  // this.$swal('No puedes iniciar sesión', error.message, 'warning')
                } else {
                  this.$controlMessage(_context3.t0);
                }

              case 22:

                this.loading = false;
                this.buttonDisabled2 = false;

                this.resetCaptchaValue();

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 19]]);
      }));

      function onSubmit() {
        return _ref5.apply(this, arguments);
      }

      return onSubmit;
    }(),
    onVerify: function onVerify(response) {
      this.captchaToken = response;
      this.expiredCaptchaToken = false;
    },
    onExpired: function onExpired() {
      this.expiredCaptchaToken = true;
    },
    resetCaptchaValue: function resetCaptchaValue() {
      this.$refs.recaptcha.reset();
      this.captchaToken = '';
      this.expiredCaptchaToken = false;
    }
  },
  watch: {
    password: function password() {
      this.isLoginError = false;
    },
    user: function user() {
      this.isLoginError = false;
    }
  },
  computed: {
    userErrorMessage: function userErrorMessage() {
      return [!this.$v.user.$dirty || this.$v.user.required || "No es un usuario válido", !this.$v.user.$dirty || this.$v.user.minLength || "Debes ingresar minimo 4 caracteres"].filter(function (val) {
        return typeof val == "string";
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index.vue
// module chunks = 19